import styled from '@emotion/styled';

export const RequestErrorItemContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette?.brand.neutral.base};
`;

export const RequestErrorItemContent = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
